export const selectExportData = state => state.exportData && state.exportData.data;

export const selectExportDataIsLoading = state => state.exportData && state.exportData.isLoading;
